module.exports = __webpack_public_path__ + "static/media/Bohunice.21c99078.jpg";